<template>
  <div class="hidden sm:block">
    <div class="py-8">
      <div class="border-t dark:border-gray-600 border-gray-300" />
    </div>
  </div>
</template>
